import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import NestedForm from '../../FormNested/NestedForm';

export default function RepeaterFieldWidget<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <NestedForm<Model>
            formName={`${props.formName}--repeater-widget`}
            config={props.config.form}
            skipFormComponent={true}
    />;
}
